module.exports = "<p>\n  title works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// D:/Sonali/JCCBViewOnlyProject/ViewOnlyJCCBfrontend19112022/InternetBanking6.3frontend/src/app/title/title.component.html
// module id = ../../../../../src/app/title/title.component.html
// module chunks = main